function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Livello_2",
  "data-name": "Livello 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Livello_1-2",
  "data-name": "Livello 1"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "18.38 0 4.82 7.83 31.94 7.83 18.38 0"
}), /*#__PURE__*/React.createElement("rect", {
  y: 7.83,
  width: 36.76,
  height: 4.57,
  rx: 0.86
}), /*#__PURE__*/React.createElement("rect", {
  y: 32.19,
  width: 36.76,
  height: 4.57,
  rx: 0.86
}), /*#__PURE__*/React.createElement("rect", {
  x: -5.07,
  y: 20.01,
  width: 19.79,
  height: 4.57,
  transform: "translate(27.12 17.48) rotate(90)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 22.17,
  y: 20.01,
  width: 19.79,
  height: 4.57,
  transform: "translate(54.36 -9.77) rotate(90)"
})));

function SvgBank2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.76 36.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank2);
export default __webpack_public_path__ + "static/media/bank2.5f0480f8.svg";
export { ForwardRef as ReactComponent };